var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("card-token-form", {
    attrs: {
      "auth-code-required": _vm.needAuthorizationCodeMsg,
      data: _vm.model
    },
    on: {
      ok: function($event) {
        return _vm.createToken($event)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }